export default "__VITE_ASSET__DHIX_FBn__"